/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from 'react';
import classNames from 'classnames';

import { Button, DateTimeFormat } from '@febos-io/design';

import './item.scss';
import { filterTypes } from '../input';
import useTranslation from '../../../hooks/useTranslation';

type PropsItem = {
  filter: {
    values: {name: any}[],
    isFixed: any;
  }
  config: {
    name: any,
    type: any,
    options: any,
    field: any
  }
  className?: string;
  onRemoveFilter: (filter: any) => void;
  onClick: (configField: any) => void;
}

export function Item({
  filter,
  config,
  className,
  onRemoveFilter = () => null,
  onClick = () => null
}: PropsItem) {
  const { t } = useTranslation();
  const values = useMemo(() => {
    switch (config.type) {
      case filterTypes.SELECT:
      case filterTypes.MULTI_SELECT:
      case filterTypes.MULTI_CHECK:
        return filter.values.map((value) => {
          return config.options.find((option) => option.value === value)?.label || value;
        });
      case filterTypes.IDENTIFICATION:
        return filter.values;
      case filterTypes.DATE_RANGE:
        return filter.values;
      case filterTypes.EMAIL:
        return filter.values;
      case filterTypes.SELECT_PATIENT:
      case filterTypes.SELECT_USER:
      case filterTypes.SELECT_DATA_IN_EXAMS:
      case filterTypes.SELECT_OBJECT_IN_EXAMS:
        return filter.values[0].name;
      default:
        return filter.values;
    }
  }, [config.options, config.type, filter.values]);
  return (
    <h3
      className={`d-inline filter-item ${className}`}
    >
      <Button
        className="item-filter-values badge rounded-pill bg-primary position-relative fw-normal btn-outline-light"
        {...(!filter.isFixed) && {
          onClick: () => onClick(config.field)
        }}
      >
        <small>
          {config.name}
          :
          {' '}
          {config.type !== filterTypes.DATE_RANGE && (
            <span>
              {values?.join(', ')}
            </span>
          )}
          {config.type === filterTypes.DATE_RANGE && (
            <span>
              {values.map((value) => (
                <DateTimeFormat key={value} value={value} />
              )).reduce((prev, curr) => [prev, ` ${t('to')} `, curr])}
            </span>
          )}
        </small>
      </Button>
      {!filter.isFixed && (
        <Button
          key={config.field + '-remove'}
          icon="remove"
          theme="danger"
          size="sm"
          className={classNames(
            'item-filter-remove',
            'btn-outline-danger',
            'text-secondary',
            'position-relative',
            'badge',
            'rounded-circle',
            'ms-1',
            'translate-middle',
            'p-0'
          )}
          style={{ padding: '30px' }}
          onClick={() => onRemoveFilter(filter)}
        />
      )}
    </h3>
  );
}

export default Item;
